<div class="container">
    <mat-expansion-panel class="content-holder">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Troubleshooting files
            </mat-panel-title>
        </mat-expansion-panel-header>
        @if(troubleshootingLoading===false){
        <h3 class="tab-header">Generate troubleshooting file</h3>
        <button class="gen-button" mat-raised-button (click)="generateTroubleshootingFile()">Generate</button>
        <tools-table class="file-table" [Headers]="headers" [ApiPath]="url" [HTTPPost]="false"
            [ExtraQuery]="'?filetype=troubleshoot'+opn" [Actions]="troubleshootTableActions"
            [Search]="false"></tools-table>
        }@else {
        <mat-spinner class="spinner" [diameter]="40"></mat-spinner>
        }
    </mat-expansion-panel>
    <mat-expansion-panel class="content-holder">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Ping Device
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ping-content">
            @if (pingLoading == true){
            <div class="spinner-container">
                <mat-spinner class="spinner" [diameter]="40"></mat-spinner>
            </div>
            }@else{
            @if(pingData && pingLoading == false){
            <div class="diagram-container">
                @if(imagePath){
                <img src={{imagePath}} alt="ping diagram" />
                }@else {
                <p class="error-msg">Device did not respond to ping. Check network or device status.</p>
                }
            </div>
            <div class="data-container">
                <h4>Pinging: {{pingData.Statistics.Addr}}</h4>
                <div class="general-statistics-container">
                    <div class="statistics-entry">
                        <p>Start:</p>
                        <p><b>{{pingData.StartTime}}</b></p>
                    </div>
                    <div class="statistics-entry">
                        <p>End: </p>
                        <p><b>{{pingData.EndTime}}</b></p>
                    </div>
                    <div class="statistics-entry">
                        <p>Sent: </p>
                        <p class="bold-text"><b>{{pingData.Statistics.PacketsSent}}</b></p>
                    </div>
                    <div class="statistics-entry">
                        <p>Received:</p>
                        <p><b>{{pingData.Statistics.PacketsRecv}}</b></p>
                    </div>
                </div>
                <div class="overall-ping-container">
                    <div [style]="'background-color:'+getPingColor(pingData.Statistics.AvgRtt)"
                        class="statistics-entry averages">
                        <p>Avg RTT:</p>
                        <p><b>
                                {{pingData.Statistics.AvgRtt}}</b></p>
                    </div>
                    <div class="statistics-entry averages">
                        <p>Min RTT:</p>
                        <p><b>
                                {{pingData.Statistics.MinRtt}}</b></p>
                    </div>
                    <div class="statistics-entry averages">
                        <p>Max RTT:</p>
                        <p><b>
                                {{pingData.Statistics.MaxRtt}}</b></p>
                    </div>
                </div>
                <div class="ping-data-container">
                    @for(ping of pingData.Packets;track ping; let i =$index){
                    <div class="ping-row">
                        <div>
                            <p>Ping {{i+1}}</p>
                        </div>
                        <div>
                            <p>Sent: <b>{{ping.Nbytes}} bytes</b></p>
                        </div>
                        <div>
                            <p>Latency: <b>{{ping.Rtt}} ms.</b></p>
                        </div>
                    </div>
                    }
                </div>
                <br />
                @if(pingData!=null){
                <div class="button-container">
                    <button mat-raised-button (click)="clear()"><span class="material-icons">replay</span>Clear</button>
                    <button mat-raised-button (click)="pingDevice(selectedIp)"><span
                            class="material-icons">replay</span>Ping Again</button>
                </div>
                }@else {
                @if(!troubleshootingLoading) {
                <div class="ip-list">
                    @if(ips!.VpnIp!=null && ips!.VpnIp!=""){
                    <div class="ip-entry">
                        <p class="ip">VPN IP: {{ips!.VpnIp}}</p>
                        <div class="buttons">
                            <button mat-raised-button type="button" (click)="pingDevice(ips!.VpnIp)">
                                <span class="material-icons">replay</span> Ping
                            </button>
                        </div>
                    </div>
                    }
                    @for(ip of ips!.StandardCheckInIPs; track ip;){
                    <div class="ip-entry">
                        <p class="ip">IP: {{ip}}</p>
                        <div class="buttons">
                            <button mat-raised-button type="button" (click)="pingDevice(ip)">
                                <span class="material-icons">replay</span>Ping
                            </button>
                        </div>
                    </div>
                    }
                </div>
                }
                }
            </div>
            }
            @else {
            @if(ips==null || ((ips.StandardCheckInIPs==null ||
            ips.StandardCheckInIPs.length==0)&&(ips.VpnIp==""||ips.VpnIp==null))){
            <p> No IP addresses available for this device. </p>
            }@else{
            @if(!pingLoading) {
            <div class="ip-list">
                @if(ips.VpnIp!=null && ips.VpnIp!=""){
                <div class="ip-entry">
                    <p class="ip">VPN IP: {{ips.VpnIp}}</p>
                    <div class="buttons">
                        <button mat-raised-button type="button" (click)="pingDevice(ips.VpnIp)">
                            <span class="material-icons">replay</span> Ping
                        </button>
                    </div>
                </div>
                }
                @for(ip of ips.StandardCheckInIPs; track ip;){
                <div class="ip-entry">
                    <p class="ip">IP: {{ip}}</p>
                    <div class="buttons">
                        <button mat-raised-button type="button" (click)="pingDevice(ip)">
                            <span class="material-icons">replay</span>Ping
                        </button>
                    </div>
                </div>
                }
            </div>
            }
            }
            }
            }


        </div>
    </mat-expansion-panel>
    <mat-expansion-panel class="content-holder">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Ping IP using Device
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="ping-content">
            @if (pingFromRouterLoading == true){
            <div class="spinner-container">
                <mat-spinner class="spinner" [diameter]="40"></mat-spinner>
            </div>
            }@else{
            @if(pingFromRouterData && pingFromRouterData.Statistics && pingFromRouterLoading == false){
            <div class="diagram-container">
                @if(pingFromRouterImagePath){
                <img src={{pingFromRouterImagePath}} alt="ping diagram" />
                }@else {
                <p class="error-msg">IP did not respond to ping.</p>
                }
            </div>
            <div class="data-container">
                <h4>Pinging: {{pingFromRouterAddress}}</h4>
                <div class="general-statistics-container">
                    <div class="statistics-entry">
                        <p>Sent: </p>
                        <p class="bold-text"><b>{{pingFromRouterData.Statistics.PacketsSent}}</b></p>
                    </div>
                    <div class="statistics-entry">
                        <p>Received:</p>
                        <p><b>{{pingFromRouterData.Statistics.PacketsRecv}}</b></p>
                    </div>
                </div>
                <div class="overall-ping-container">
                    <div [style]="'background-color:'+getPingColor(pingFromRouterData.Statistics.AvgRtt)"
                        class="statistics-entry averages">
                        <p>Avg RTT:</p>
                        <p><b>
                                {{pingFromRouterData.Statistics.AvgRtt}}</b></p>
                    </div>
                    <div class="statistics-entry averages">
                        <p>Min RTT:</p>
                        <p><b>
                                {{pingFromRouterData.Statistics.MinRtt}}</b></p>
                    </div>
                    <div class="statistics-entry averages">
                        <p>Max RTT:</p>
                        <p><b>
                                {{pingFromRouterData.Statistics.MaxRtt}}</b></p>
                    </div>
                </div>
                <div class="ping-data-container">
                    @for(ping of pingFromRouterData.Packets;track ping; let i =$index){
                    <div class="ping-row">
                        <div>
                            <p>Ping {{i+1}}</p>
                        </div>
                        <div>
                            <p>Sent: <b>{{ping.Nbytes}} bytes</b></p>
                        </div>
                        <div>
                            <p>Latency: <b>{{ping.Rtt}} ms.</b></p>
                        </div>
                    </div>
                    }
                </div>
                <br />
                <div class="ip-input">
                    <mat-form-field>
                        <mat-label>Enter IP to ping</mat-label>
                        <input matInput [(ngModel)]="pingFromRouterAddress" />
                    </mat-form-field>
                    <button mat-raised-button type="button" (click)="pingFromDevice()">
                        <mat-icon>replay</mat-icon> Ping
                    </button>
                </div>
            </div>
            }
            @else {
            @if(!pingFromRouterLoading) {
            <div class="ip-input">
                <mat-form-field>
                    <mat-label>Enter IP to ping</mat-label>
                    <input matInput [(ngModel)]="pingFromRouterAddress" />
                </mat-form-field>
                <button mat-raised-button type="button" (click)="pingFromDevice()">
                    <mat-icon>replay</mat-icon> Ping
                </button>
            </div>
            }
            }
            }


        </div>
    </mat-expansion-panel>

    @if(isHipSuperUser){
    <mat-expansion-panel class="content-holder">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Traceroute
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="traceroute-content">
          @if (tracerouteLoading == true){
            <div class="spinner-container">
                <mat-spinner class="spinner" [diameter]="40"></mat-spinner>
            </div>
          }@else{
            @if(!tracerouteLoading) {
              <div class="ip-input">
                <mat-form-field>
                  <mat-label>Enter IP to Traceroute to</mat-label>
                  <input matInput [(ngModel)]="tracerouteIp" />
                </mat-form-field>
                <button mat-raised-button type="button" (click)="traceRouteIP()">
                  <mat-icon>replay</mat-icon> Start
                </button>
              </div>
            }
            @if(tracerouteData && tracerouteLoading == false){
              @if(tracerouteData.Hops.length > 0) {
<!--                <tools-table style="width: 100%;" [Headers]="traceRouteHeaders" [Data]="tracerouteData.Hops"-->
<!--                    [Search]="false" [Selectable]="false" [HasCustomPaginator]="true">-->
<!--                </tools-table>-->
                <div class="traceroute-output">
                  <div class="hop-line">
                    <span class="hop-number">$</span>
                    <span class="address">traceroute {{ tracerouteIp }}</span>
                  </div>
                  @for (hop of tracerouteData.Hops; track hop.HopNumber) {
                    <div class="hop-line">
                      <span class="hop-number">{{ hop.HopNumber }}</span>
                      @if (hop.Addr === '*') {
                        <span class="timeout">*</span>
                      } @else {
                        <span class="address">{{ hop.Addr }}</span>
                        <span class="time">{{ hop.TimeTaken | number:'1.3-3' }} ms</span>
                      }
                    </div>
                  }
                </div>
              }@else {
                <p>No traceroute data available for the provided IP.</p>
              }
            }
          }
        </div>
    </mat-expansion-panel>

    <mat-expansion-panel class="content-holder" (opened)="speedTestExpanded()">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Speedtest
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="speedtest-content">
            @if(speedtestLoading == true){
            <div class="spinner-container">
                <mat-spinner class="spinner" [diameter]="40"></mat-spinner>
            </div>
            }@else {
            @if(speedtestData == null && selectedSpeedtestOption==null && speedtestOptions!=null &&
            speedtestOptions.length>0){
            <tools-table (Selected)="onSpeedtestOptionSelected($event)" [Data]="speedtestOptions"
                [Headers]="speedtestHeaders" [HasCustomPaginator]="true" [Search]="false" [disableRowClick]="false"
                [ButtonRows]="true" [Selectable]="false">
            </tools-table>
            }@else if(speedtestData != null){
            <div class="data-container">
                <h4>Speedtest Results</h4>
                <h5>State: {{speedtestData.State}}</h5>
                <p>Last Updated: {{speedtestData.Timestamp*1000 | date:'yyyy-MM-dd HH:mm:ss'}}</p>
                <div class="statistics-entry">
                    <p>Download Speed:</p>
                    <p><b>{{(speedtestData.AverageDownloadSpeed??0)/1000}} Mbps</b></p>
                </div>
                <div class="statistics-entry">
                    <p>Upload Speed:</p>
                    <p><b>{{(speedtestData.AverageUploadSpeed??0)/1000}} Mbps</b></p>
                </div>
                <div class="statistics-entry">
                    <p>Total Downloaded:</p>
                    <p><b>{{(speedtestData.TotalDownloaded??0)/1000000}} MB</b></p>
                </div>
                <div class="statistics-entry">
                    <p>Total Uploaded:</p>
                    <p><b>{{(speedtestData.TotalUploaded??0)/1000000}} MB</b></p>
                </div>
                <div class="button-container">
                    @if(speedtestInProgress===false){
                    <button mat-raised-button (click)="clearSpeedtest()"><span
                            class="material-icons">replay</span>Clear</button>
                    }@else {
                    <mat-spinner class="spinner" [diameter]="40"></mat-spinner>
                    }
                </div>
            </div>
            }
            }

        </div>
    </mat-expansion-panel>
    }


</div>
